module.exports = __webpack_public_path__ + "img/banner-principal.d6a10c90.png";